import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { BulletedPoints } from '../BulletedPoints';
import { BulletedPointsList } from '../BulletedPointsList';
import { Countries } from '../Countries';
import { GenericText } from '../GenericText';
import { InfoLabelWithToolTip } from '../InfoLabelWithToolTip';
import { jsx as _jsx } from "react/jsx-runtime";
const BULLET_POINTS_MAX_COUNT = 3;
const BULLET_POINTS_LIST_MAX_COUNT = 2;
// eslint-disable-next-line max-lines-per-function, complexity
export const GenericComponent = props => {
  switch (props.type) {
    case 'heading-with-bullet':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'heading-with-bullet',
          text: props.text
        }]
      });
    case 'text-label-bold-data-items':
      return /*#__PURE__*/_jsx(GenericText, {
        items: props.items
      });
    case 'bold-text-normal-data':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'bold-text-normal-data',
          text: props.text,
          data: props.data
        }]
      });
    case 'text':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'text',
          text: props.text
        }]
      });
    case 'bold-text':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'bold-text',
          text: props.text
        }]
      });
    case 'link':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'link',
          text: props.text,
          href: props.href
        }]
      });
    case 'link-with-icon':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'link-with-icon',
          text: props.text,
          href: props.href
        }]
      });
    case 'info-label-with-tooltip':
      return /*#__PURE__*/_jsx(InfoLabelWithToolTip, {
        text: props.text,
        content: props.content
      });
    case 'email':
      return /*#__PURE__*/_jsx(GenericText, {
        items: [{
          type: 'email',
          text: props.text,
          mailId: props.mailId
        }]
      });
    case 'rich-text':
      return /*#__PURE__*/_jsx(GenericText, {
        items: props.items
      });
    case 'bullet-points':
      {
        return /*#__PURE__*/_jsx(BulletedPoints, {
          points: props.points,
          expandButton: {
            maxCount: BULLET_POINTS_MAX_COUNT,
            text: 'Expand all'
          }
        });
      }
    case 'bullet-points-list':
      {
        return /*#__PURE__*/_jsx(BulletedPointsList, {
          bulletedList: props.bulletedList,
          expandButton: {
            maxListsCount: BULLET_POINTS_LIST_MAX_COUNT,
            maxCount: BULLET_POINTS_MAX_COUNT,
            text: 'Expand all'
          }
        });
      }
    case 'countries':
      {
        const {
            type
          } = props,
          countriesProps = _objectWithoutProperties(props, _excluded);
        return /*#__PURE__*/_jsx(Countries, _objectSpread({}, countriesProps));
      }
    default:
      return null;
  }
};